import { render } from "./DashboardLayout.vue?vue&type=template&id=6304d740"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=6304d740&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__